import { LADDER, levelOf } from "../lib/bopta";

const rungStyle = (n, cur) => {
  if (n === cur) return { background: "var(--teal)", color: "#fff", borderColor: "var(--teal)" };
  if (n === cur + 1) return { borderColor: "var(--orange)", borderStyle: "dashed" };
  return { borderColor: "var(--line)", opacity: 0.55 };
};

export const LadderCard = ({ score, manager }) => {
  const cur = levelOf(score);
  const c = LADDER[cur - 1];
  const nxt = LADDER[cur];
  return (
    <div className="panel p-7" data-testid="ladder-card">
      <p className="kicker">Delegation ladder</p>
      <p className="mt-3 text-[11px] font-bold uppercase tracking-[0.14em] muted" data-testid="ladder-translation">Level {cur} · {c.translation}</p>
      <p className="mt-1 text-2xl font-bold" data-testid="ladder-identity">{manager ? c.persona : c.growth}</p>
      <p className="mt-2 text-sm muted">{c.reality}</p>
      <div className="mt-5 flex flex-col-reverse gap-1.5">
        {LADDER.map((l) => (
          <div key={l.n} className="flex items-center justify-between rounded-lg border px-3 py-2 text-xs" style={rungStyle(l.n, cur)} data-testid={`ladder-rung-${l.n}`}>
            <span><b>L{l.n}</b> · {l.translation}</span>
            <span>{manager ? l.persona : l.growth} · {l.range}</span>
          </div>
        ))}
      </div>
      {nxt ? (
        <p className="mt-5 rounded-lg bg-[#FFEEE5] p-4 text-sm" data-testid="ladder-next"><b>To reach L{nxt.n} · {nxt.translation}:</b> {c.next}</p>
      ) : (
        <p className="mt-5 rounded-lg bg-[var(--tint)] p-4 text-sm" data-testid="ladder-next"><b>Top of the ladder.</b> {c.next}</p>
      )}
    </div>
  );
};

export const spreadLine = (dims, names) => {
  const ks = Object.keys(dims);
  const hi = ks.reduce((a, b) => (dims[b] > dims[a] ? b : a));
  const lo = ks.reduce((a, b) => (dims[b] < dims[a] ? b : a));
  const lh = levelOf(dims[hi]);
  const ll = levelOf(dims[lo]);
  if (lh === ll) return `You operate at L${lh} across every dimension.`;
  return `You execute at L${lh} in ${names[hi]} but L${ll} in ${names[lo]}.`;
};
